/**
 * @generated SignedSource<<19b6758e54026434c8c7db583465a5a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateCustomerTaxInformationInput = {
  id: string;
  vatId?: string | null | undefined;
};
export type CustomerAccountViewUpdateCustomerTaxInformationMutation$variables = {
  input: UpdateCustomerTaxInformationInput;
};
export type CustomerAccountViewUpdateCustomerTaxInformationMutation$data = {
  readonly updateCustomerTaxInformation: {
    readonly id: string;
    readonly vatId: string | null | undefined;
  };
};
export type CustomerAccountViewUpdateCustomerTaxInformationMutation = {
  response: CustomerAccountViewUpdateCustomerTaxInformationMutation$data;
  variables: CustomerAccountViewUpdateCustomerTaxInformationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CustomerAccount",
    "kind": "LinkedField",
    "name": "updateCustomerTaxInformation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vatId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomerAccountViewUpdateCustomerTaxInformationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CustomerAccountViewUpdateCustomerTaxInformationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c1752d99507487cafac17d94c0e059af",
    "id": null,
    "metadata": {},
    "name": "CustomerAccountViewUpdateCustomerTaxInformationMutation",
    "operationKind": "mutation",
    "text": "mutation CustomerAccountViewUpdateCustomerTaxInformationMutation(\n  $input: UpdateCustomerTaxInformationInput!\n) {\n  updateCustomerTaxInformation(input: $input) {\n    id\n    vatId\n  }\n}\n"
  }
};
})();

(node as any).hash = "7f4bc72284525909589ce14fda094137";

export default node;
